module.exports = {"resourceQuery":null,"query":"?query","prev":"module.exports = \"error\";"}


/*****************
 ** WEBPACK FOOTER
 ** ./resolving/context/loaders/queryloader.js?query!./resolving/context/~/subcontent/index.js
 ** module id = 3
 ** module chunks = 0
 **/